import React, { useState } from 'react';
import Helmet from 'react-helmet';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import AdminLayout from '../../../Shared/AdminLayout';
import DataContainer from '../../../Shared/DataContainer';
import DropdownButton from '../../../Shared/DropdownButton';
import Pagination from '../../../Shared/Pagination';
import LoadingButton from '../../../Shared/LoadingButton';
import TextInput from '../../../Shared/TextInput';
import Icon from '../../../Shared/Icon';
import { can } from '../../../utils';
import * as moment from 'moment';
import axios from 'axios';

const Delivery = () => {
     const { auth, errors, data } = usePage().props;
     const [sending, setSending] = useState(false);
     const [values, setValues] = useState({
          _token: data,
          search: '',
          name: '',
          result: [],
          error: null
     });

     function handleChange(e, index) {
          e.persist();
          const value = e.target.value;
          const key = e.target.name;
          setValues(values => ({
               ...values,
               [key]: value
          }));
     }

     function handleSubmit(e) {
          e.preventDefault();
          if(values.search != '' || values.name != ''){
               setValues(values => ({
                    ...values,
                    error: null
               }));
               setSending(true);
               axios.post(route('delivery.search'), values).then((response) => {
                    // setSaved(true);
                    console.log(response);
                    setSending(false);
                    setValues(values => ({
                         ...values,
                         name: '',
                         result: response.data,
                         errors: []
                    }));
               }).catch((error) => {
                    setValues(values => ({
                         ...values,
                         error: error.response.data.message
                    }));
                    setSending(false);
               });
          }
     }

     return (
          <React.Fragment key="security-index">
               <Helmet>
                    <title>Deliveries</title>
               </Helmet>
               <div className="max-w-7xl mx-auto p-2">
                    <InertiaLink className="font-semibold text-md text-gray-700 hover:text-gray-800 leading-tight" href={route('home')}>Dashboard</InertiaLink> | <span className="text-md text-gray-700 leading-tight">Deliveries</span>
               </div>
               <DataContainer>
                    <div className="flex col-span-12">
                         <span className="text-md border border-2 rounded-l px-4 py-2 bg-gray-300 whitespace-no-wrap">FAC-</span>
                         <input onChange={handleChange} name="search" className="border border-2 px-4 py-2 w-full focus:outline-none" type="text" placeholder="0123456789" />
                         <input onChange={handleChange} name="name" className="border border-2 rounded-r px-4 py-2 w-full focus:outline-none" type="text" placeholder="Nom ou Num. Telephone" />
                         {can(auth.user, 'search-delivery') && (<button onClick={handleSubmit} loading={sending} className="w-1/4 inline-flex items-center px-4 py-1 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white text-center uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray disabled:opacity-25 transition ease-in-out duration-150 ml-4">
                              Search
                         </button>)}
                    </div>
                    {values.error && (<div className="rounded col-span-12 bg-red-600 text-white border border-red-500 px-4 py-4 text-center">{values.error}</div>)}
               </DataContainer>
               {(values.result.length > 0) && (<DataContainer>
                    <table className="table-fixed col-span-12 text-sm">
                         <thead className="bg-gray-100">
                              <tr>
                                   <th className="px-4 py-2">Receipt No.</th>
                                   <th className="px-4 py-2">Sender</th>
                                   <th className="px-4 py-2">Reciever</th>
                                   <th className="px-4 py-2">Location</th>
                                   <th className="px-4 py-2">Date</th>
                                   <th className="px-4 py-2">Status</th>
                                   <th className="px-4 py-2"></th>
                              </tr>
                         </thead>
                         <tbody>
                              {values.result.map(({id, number, status, filter, color, view_only, is_location, location, address, name, sender, created}) => {
                                   return <tr key={id}>
                                        <td className="border px-4 py-2 text-center">{number}</td>
                                        <td className="border px-4 py-2 text-center">{sender}</td>
                                        <td className="border px-4 py-2 text-center">{name}</td>
                                        <td className="border px-4 py-2 text-center">{location}</td>
                                        <td className="border px-4 py-2 text-center">
                                             {moment(created).format('DD MMM YYYY')}
                                        </td>
                                        <td className="border px-4 py-2 text-center font-semibold" style={{color: `#${color}`}}>{status}</td>
                                        <td className="border px-4 py-2 text-center">
                                             <DropdownButton caption="Actions" color="blue">
                                                  <InertiaLink href={route('purchase.show', id)} className="flex block px-6 py-2 text-gray-600 hover:bg-gray-100 hover:text-gray-700">
                                                       <Icon name={'eye'} className={'fill-current w-5 h-5 mr-2'} /> View Details
                                                  </InertiaLink>
                                                  {(!view_only && is_location && can(auth.user, 'make-delivery')) && (<InertiaLink href={route('delivery.prepare', id)} className={`flex block px-6 py-2 text-gray-${(filter != 2)?'600':'300 line-through'} hover:bg-gray-100 hover:text-gray-700`}>
                                                       <Icon name={'prepare'} className={'fill-current w-5 h-5 mr-2'} /> Deliver
                                                  </InertiaLink>)}
                                             </DropdownButton>
                                        </td>
                                   </tr>
                              })}
                         </tbody>
                    </table>
               </DataContainer>)}
          </React.Fragment>
     );
};

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Delivery.layout = page => <AdminLayout children={page} header={'Deliveries'} />;

export default Delivery;
